import { DEFAULT_LOCALE } from '../../const/translations/LOCALE';
import * as actionTypes from '../actions/widget/actionTypes';

const initialState = {
    baseURL: null,
    wsBaseURL: null,
    strictPath: false,
    showCloseButton: true,
    style: 'inline',
    locale: DEFAULT_LOCALE,
    user: null,
    password: null
};

const reducer = (state = initialState, {type, ...payload}) => {
    switch(type) {
        case actionTypes.LOAD_WIDGET_SETTINGS:
            const {baseURL, wsBaseURL, strictPath, showCloseButton, style, user, password} = payload;
            return {
                ...state,
                baseURL,
                wsBaseURL,
                strictPath,
                showCloseButton,
                style: style || 'dev',
                locale: DEFAULT_LOCALE,
                user,
                password
            };
        default:
            return state;
    }
};

export default reducer